import { ProcedureSpecificationMaterialRulesConfig } from '@core/procedure-helpers/models/specification-material-rules-config';
import { rulesForBridgeFixedRestorative } from './specification-material-rules/bridge-fixed-restorative';

export const procedureBridgeSpecificationMaterialRules: ProcedureSpecificationMaterialRulesConfig = {
	ProcedureRules: [rulesForBridgeFixedRestorative]
};
